import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { ProfileMatch } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface ProfileMatchesResponse {
  data: ProfileMatch[]
  pagination?: {
    totalItems: number
    totalPages: number
    currentPage: number
    pageSize: number
  }
}

export const useProfileMatches = (
  userId: string,
  page: number = 1,
  pageSize: number = 20
) => {
  const fetchWithAuth = useFetchWithAuth()
  const getProfileMatches: QueryFunction<ProfileMatchesResponse> = async () => {
    const response = await fetchWithAuth(`${URL}/profile/${userId}/matches`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId,
        page,
        pageSize,
      }),
    })
    return response
  }

  return useQuery({
    queryKey: ['profileMatches', userId, page, pageSize] as const,
    queryFn: getProfileMatches,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: userId.length > 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}
